const { cardComponentName, searchApiUrl } = require('./types');
const loremblocksum = require('./loremblocksum');
const {
  defaultFilters,
} = require('./filters');
const createAdcellQueryParams = require('./create-adcell-query-params');

const normalizeSearch = (search) => decodeURIComponent(search).replace(/(\s|%20|\+)/g, '+');
const defaultFiltersKeys = Object.keys(defaultFilters);
const stateHistory = [];
const adjustSearchIndexMetadata = (showNextLinkElem = true) => {
  const robotsMetaElem = document.querySelector('meta[name="robots"]');
  if (robotsMetaElem) {
    const value = robotsMetaElem.getAttribute('content').replace('noindex', 'index');
    if (window.location.href.indexOf('/page/') > -1 || window.location.search) {
      robotsMetaElem.setAttribute('content', `no${value}`);
    } else {
      robotsMetaElem.setAttribute('content', value);
    }
  }

  const canonicalMetaElem = document.querySelector('link[rel="canonical"]');
  if (canonicalMetaElem) {
    canonicalMetaElem.setAttribute('href', window.location.href.replace(window.location.search, ''));
  }

  window.swinger.$('link[rel="alternate"]').forEach((elem) => {
    const baseUrl = elem.href.replace(/\/page\/\d+$/, '');
    if (window.location.href.indexOf('/page/') > -1) {
      const pagePath = window.location.pathname.replace(/^.*(\/page\/\d+)$/, '$1');
      const composedUrl = `${baseUrl}${pagePath}`;
      elem.setAttribute('href', composedUrl);
    } else {
      elem.setAttribute('href', baseUrl);
    }
  });

  let urlParts = window.location.href.split('?');
  let currentPage = 1;
  if (window.location.pathname.indexOf('/page/') > -1) {
    currentPage = parseInt(window.location.pathname.replace(/^[\d\D]+\/page\/(\d+).*?$/i, '$1'), 10);
  }

  urlParts = window.location.href.split('?');
  let prevLinkElem = document.querySelector('head link[rel="prev"]');
  if (window.location.pathname.indexOf(`/page/${currentPage}`) > -1) {
    if (!prevLinkElem) {
      prevLinkElem = document.createElement('link');
      prevLinkElem.setAttribute('rel', 'prev');
    }
    console.log({ currentPage });
    if (currentPage > 2) {
      urlParts[0] = window.location.pathname.replace(`/page/${currentPage}`, `/page/${(currentPage - 1)}`);
    } else {
      urlParts[0] = window.location.pathname.replace(`/page/${currentPage}`, '');
    }
    prevLinkElem.setAttribute('href', urlParts.join('?'));
    document.head.appendChild(prevLinkElem);
  } else if (prevLinkElem) {
    document.head.removeChild(prevLinkElem);
  }

  urlParts = window.location.href.split('?');
  let nextLinkElem = document.querySelector('head link[rel="next"]');
  if (showNextLinkElem) {
    if (!nextLinkElem) {
      nextLinkElem = document.createElement('link');
      nextLinkElem.setAttribute('rel', 'next');
    }
    if (window.location.pathname.indexOf(`/page/${currentPage}`) > -1) {
      urlParts[0] = window.location.pathname.replace(`/page/${currentPage}`, `/page/${(currentPage + 1)}`);
    } else {
      urlParts[0] = urlParts[0].replace(/\/$/, '');
      urlParts[0] += `/page/${(currentPage + 1)}`;
    }
    nextLinkElem.setAttribute('href', urlParts.join('?'));
    document.head.appendChild(nextLinkElem);
  } else if (nextLinkElem) {
    document.head.removeChild(nextLinkElem);
  }
};
const getPreviousSearchUrl = () => {
  const stateHistoryLength = stateHistory.length;

  if (!stateHistoryLength) {
    return undefined;
  }

  return stateHistory[stateHistoryLength - 1].url;
};

module.exports = (type) => (app) => {
  let url = new URL(window.location);
  const search = decodeURIComponent(url.search).slice(1);
  const state = app.store.getState();
  const itemsPerPage = state.itemsPerPage || 36;
  let timer;
  let items = (search && search !== 'filter[streaming_type]=movie') ? [] : state.items;
  let { filters, order } = state;
  const { hardwiredFilters } = state;
  let itemsLength = items.length;
  let page = window.location.href.indexOf('/page/') > -1 ? Number(window.location.href.replace(/^[\d\D]+\/page\/(\d+).*?$/i, '$1')) : 1;
  let totalItemCount = state.totalCount;
  let elemsNextSiblingToFocus;

  const getComponentName = () => {
    const url = new URL(window.location);
    const search = decodeURIComponent(url.search).slice(1);

    switch (true) {
      default:
        return cardComponentName[type];

      case type === 'movies' && search.indexOf('filter[streaming_type]=scene') === -1 && (!hardwiredFilters || hardwiredFilters.streaming_type !== 'scene'):
        return cardComponentName.movies;

      case type === 'scenes':
      case type === 'movies' && (search.indexOf('filter[streaming_type]=scene') > -1 || (hardwiredFilters && hardwiredFilters.streaming_type === 'scene')):
        return cardComponentName.scenes;
    }
  };
  const getNextPageUrl = () => {
    const urlParts = window.location.href.split('?');

    if (window.location.pathname.indexOf(`/page/${page}`) > -1) {
      urlParts[0] = window.location.pathname.replace(`/page/${page}`, `/page/${(page + 1)}`);
    } else {
      urlParts[0] = urlParts[0].replace(/\/$/, '');
      urlParts[0] += `/page/${(page + 1)}`;
    }

    return urlParts.join('?');
  };
  const retrieve = () => {
    const state = app.store.getState();
    const url = new URL(window.location);
    const search = decodeURIComponent(url.search).slice(1);
    const params = url.searchParams;
    const filters = {};

    state.startCharacter = false;
    state.filters = (state.filters || []).map((filter) => {
      if (filter.data.multiple) {
        filter.data.value = [];
      } else {
        filter.data.value = '';
      }

      return filter;
    });
    state.q = params.get('q') || undefined;

    params.forEach((value, key) => {
      state.filters = state.filters.map((filter) => {
        if (
          filter.data.name !== key.replace('[]', '')
          && filter.data.name !== key.replace('[min]', '')
          && filter.data.name !== key.replace('[max]', '')
        ) {
          return filter;
        }

        value = `${value}`;

        if (key.indexOf('[min]') > -1) {
          filter.data.value = filter.data.value || {};
          filter.data.value.min = value;
        } else if (key.indexOf('[max]') > -1) {
          filter.data.value = filter.data.value || {};
          filter.data.value.max = value;
        } else if (key.indexOf('[]') > -1) {
          filter.data.value = filter.data.value || [];
          filter.data.value.push(value);
        } else {
          filter.data.value = value;
        }

        return filter;
      });

      if (key.indexOf('[min]') > -1) {
        const filterKey = key.replace(/filter\[([^\]]+)\]\[min\]/, '$1');
        filters[filterKey] = filters[filterKey] || {};
        filters[filterKey].min = value;
      } else if (key.indexOf('[max]') > -1) {
        const filterKey = key.replace(/filter\[([^\]]+)\]\[max\]/, '$1');
        filters[filterKey] = filters[filterKey] || {};
        filters[filterKey].max = value;
      } else if (key.indexOf('[]') > -1) {
        const filterKey = key.replace(/filter\[([^\]]+)\]\[\]/, '$1');
        filters[filterKey] = filters[filterKey] || [];
        filters[filterKey].push(value);
      } else {
        const filterKey = key.replace(/filter\[([^\]]+)\]/, '$1');
        filters[filterKey] = value;
      }
    });

    switch (true) {
      default:
        state.order = undefined;
        break;

      case params.get('order') !== null:
        state.order = params.get('order');
        break;

      case !!state.firstLetter:
        state.order = 'alpha';
        break;

      case !!state.initialOrder:
        state.order = state.initialOrder;
        break;
    }

    if ((search && search !== 'filter[streaming_type]=movie') || (!search && !itemsLength)) {
      const items = itemsLength || (
        state.items
        && state.items[0]
        && state.items[0].data.isSkeleton
      ) ? state.items : [];
      while (items.length < (itemsLength + (Math.min(itemsPerPage, 96) * page))) {
        items.push({
          component: cardComponentName[type],
          data: {
            isSkeleton: true,
            src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAGlCAQAAADqywPuAAAC70lEQVR42u3SQREAAAjDsM2/aDABv0RCr80EztVYGAtjYSwwFsbCWGAsjIWxwFgYC2OBsTAWxgJjYSyMBcbCWBgLjIWxMBYYC2NhLDAWxsJYYCyMhbHAWBgLY4GxMBbGAmNhLIwFxsJYGAuMhbEwFhgLY2EsMBbGwlhgLIyFscBYGAtjgbEwFsYCY2EsjAXGwlgYC4yFsTAWGAtjYSwwFsbCWGAsjIWxwFgYC2OBsTAWxsJYImAsjIWxwFgYC2OBsTAWxgJjYSyMBcbCWBgLjIWxMBYYC2NhLDAWxsJYYCyMhbHAWBgLY4GxMBbGAmNhLIwFxsJYGAuMhbEwFhgLY2EsMBbGwlhgLIyFscBYGAtjgbEwFsYCY2EsjAXGwlgYC4yFsTAWGAtjYSwwFsbCWGAsjIWxwFgYC2OBsTAWxgJjYSyMhbGMhbEwFsYCY2EsjAXGwlgYC4yFsTAWGAtjYSwwFsbCWGAsjIWxwFgYC2OBsTAWxgJjYSyMBcbCWBgLjIWxMBYYC2NhLDAWxsJYYCyMhbHAWBgLY4GxMBbGAmNhLIwFxsJYGAuMhbEwFhgLY2EsMBbGwlhgLIyFscBYGAtjgbEwFsYCY2EsjAXGwlgYC4yFsTAWxjIWxsJYGAuMhbEwFhgLY2EsMBbGwlhgLIyFscBYGAtjgbEwFsYCY2EsjAXGwlgYC4yFsTAWGAtjYSwwFsbCWGAsjIWxwFgYC2OBsTAWxgJjYSyMBcbCWBgLjIWxMBYYC2NhLDAWxsJYYCyMhbHAWBgLY4GxMBbGAmNhLIwFxsJYGAuMhbEwFhgLY2EsMBbGwlhgLIyFsTCWCBgLY2EsMBbGwlhgLIyFscBYGAtjgbEwFsYCY2EsjAXGwlgYC4yFsTAWGAtjYSwwFsbCWGAsjIWxwFgYC2OBsTAWxgJjYSyMBcbCWBgLjIWxMBYYC2NhLDAWxsJYYCyMhbHAWBgLY4GxMBbGAmNhLIwFxsJYGAuMhbEwFhiLZwv616UQP+bDWQAAAABJRU5ErkJggg==',
            name: loremblocksum(20),
            text: loremblocksum(5),
          },
        });
      }

      if (!window.swinger.navigation.isBackOrReloadNavigation) {
        state.items = items;
      }
    }

    state.filtered = true;
    state.showMoreButton = totalItemCount > state.items.length;
    state.moreButtonHref = getNextPageUrl();
    state.previousResultUrl = getPreviousSearchUrl();
    state.showResetButton = state.filterCount && !state.items.length;

    adjustSearchIndexMetadata(state.showMoreButton);

    app.store.dispatch({
      type: 'UPDATE',
      value: state,
    });

    window.setTimeout(() => {
      if (window.performance && window.performance.measure) {
        window.performance.mark(`FilterWorker ${search} start`);
      }

      const searchUrl = (() => {
        switch (true) {
          default:
            return searchApiUrl[type];

          case type === 'movies' && search.indexOf('filter[streaming_type]=scene') === -1 && (!hardwiredFilters || hardwiredFilters.streaming_type !== 'scenes'):
            return searchApiUrl.movies;

          case type === 'scenes':
          case type === 'movies' && (search.indexOf('filter[streaming_type]=scene') > -1 || (hardwiredFilters && hardwiredFilters.streaming_type === 'scenes')):
            return searchApiUrl.scenes;
        }
      })();

      window.swinger.webworker.filterWorker.postMessage({
        action: 'retrieve',
        url: `${window.swinger.config.apiBase}${searchUrl}`,
        language: window.swinger.config.language,
        search: `${search}${state.order && search.indexOf(`order=${state.order}`) === -1 ? `&order=${state.order}` : ''}`,
        source: `${type}overview`,
        referrer: window.location.href,
        hardwiredFilters,
        itemsPerPage: !itemsLength && page > 1 ? page * itemsPerPage : itemsPerPage,
        pageNumber: Math.ceil(itemsLength / itemsPerPage) + 1,
        config: window.swinger.config,
      });
    }, window.swinger.navigation.isBackOrReloadNavigation ? 0 : 0);

    window.swinger.eventHub.trigger(document, 'swinger-loading-indicator:show');
  };
  const reset = (name, value) => {
    const url = new URL(window.location);
    if (value && name) {
      if (url.searchParams.has(name)) {
        let values = url.searchParams.getAll(name);
        values = values.filter((v) => `${v}` !== `${value}`);
        url.searchParams.delete(name);

        // Re-add the filtered values if any remain
        values.forEach((value) => url.searchParams.append(name, value));
      }
    } else {
      // Reset URL completely if no specific parameter is given
      url.search = '';
    }
    window.swinger.eventHub.trigger(window, 'swinger-before-pushstate');
    history.pushState(null, document.title, url.href);
    stateHistory.push({
      url: `${window.location.pathname}${window.location.search}`,
      state: JSON.parse(JSON.stringify(app.store.getState())),
    });
    itemsLength = 0;
    page = 1;
    retrieve();
  };

  const nextPage = () => {
    const url = getNextPageUrl();
    window.swinger.eventHub.trigger(window, 'swinger-before-pushstate');
    history.pushState(null, document.title, url);
    page += 1;
    retrieve();
  };
  const handleBlur = (e) => {
    const input = window.swinger.eventHub.getTarget(e);

    if (input.checkValidity()) {
      return;
    }

    input.value = null;
  };
  const handleInput = (e, timeout) => {
    timeout = timeout || 20;
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      const input = window.swinger.eventHub.getTarget(e);
      const form = input.closest('form');

      if (!form) {
        return;
      }

      const formData = new FormData(form);

      if (form.checkValidity() === false) {
        return; // Don't update if the input is not valid
      }

      const keysToDelete = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const pair of formData.entries()) {
        if (!pair[1] && pair[1] !== false) {
          keysToDelete.push(pair[0]);
        }
        if (pair[0] === 'filter[streaming_type]' && pair[1] === 'movie') {
          // keysToDelete.push(pair[0]);
        }
        for (let i = 0; i < defaultFiltersKeys.length; i += 1) {
          if (
            pair[0] === `filter[${defaultFiltersKeys[i]}]`
            && pair[1] === `${defaultFilters[defaultFiltersKeys[i]]}`
          ) {
            keysToDelete.push(pair[0]);
          }
        }
      }
      keysToDelete.forEach((key) => formData.delete(key));

      const queryComponents = [...formData.entries()].map((e) => `${encodeURIComponent(e[0])}=${encodeURIComponent(e[1])}`);
      const queryString = decodeURIComponent(new URLSearchParams(queryComponents.join('&')));
      const url = new URL(window.location);
      const search = decodeURIComponent(url.search).slice(1);
      const startCharacterSearch = url.pathname.match(/\/([a-z]|0-9)\/?$/i);
      let startCharacter = false;
      // eslint-disable-next-line no-restricted-syntax
      for (const pair of formData.entries()) {
        // Remove first_letter from query string and put it into the path instead
        if (pair[0] === 'filter[first_letter]' && pair[1]) {
          startCharacter = pair[1].toLowerCase();
          formData.delete(pair[0]);
        }
      }

      if (
        startCharacterSearch && startCharacterSearch[1] === startCharacter
        && search === queryString
      ) {
        return;
      }

      url.search = queryString;

      window.swinger.eventHub.trigger(window, 'swinger-before-pushstate');
      history.pushState(null, document.title, url.toString().replace(/\/page\/\d+/i, '/'));
      stateHistory.push({
        url: `${window.location.pathname}${window.location.search}`,
        state: JSON.parse(JSON.stringify(app.store.getState())),
      });
      itemsLength = 0;
      page = 1;
      retrieve();
    }, timeout);
  };
  const renderResults = () => {
    const state = app.store.getState();

    if (window.performance && window.performance.measure) {
      window.performance.mark('RenderResults start');
    }

    state.filtered = true;
    state.items = items.slice(0, itemsLength).map((item) => {
      const type = item.component.replace('card-', '');

      item.data.isLiked = window.swinger.user.getItemLikedState(type, item.data.id);

      switch (type) {
        default:
          break;

        case 'movie':
        case 'scene':
        case 'clip':
          item.data.own = ['purchased', 'rented'].indexOf(window.swinger.user.getItemOwnState(item.data.id).status) > -1;
          break;
      }

      return item;
    });
    state.filters = !state.hideFilters ? filters : [];
    state.showMoreButton = state.items.length % itemsPerPage === 0;
    state.previousResultUrl = getPreviousSearchUrl();
    state.showResetButton = state.filterCount && !state.items.length;
    state.totalCount = totalItemCount;
    state.order = order;

    app.store.dispatch({
      type: 'UPDATE',
      value: state,
    });

    history.replaceState(state, document.title, window.location.href);

    if (window.performance && window.performance.measure) {
      window.performance.mark('RenderResults end');
      window.performance.measure(
        'RenderResults',
        'RenderResults start',
        'RenderResults end',
      );
    }
  };

  window.swinger.webworker.filterWorker.postMessage({
    action: 'preconnect',
    url: `${window.swinger.config.apiBase}${window.swinger.config.apiRoutes.config}`,
    language: window.swinger.config.language,
    referrer: window.location.href,
  });

  window.swinger.webworker.filterWorker.addEventListener('message', (e) => {
    const url = new URL(window.location);
    const search = decodeURIComponent(url.search).slice(1);

    if (e.data.action !== 'result') {
      return;
    }

    let workerSearch = e.data.search;

    if (state.firstLetter) {
      workerSearch = workerSearch.replace('&order=alpha', '');
    }
    if (state.initialOrder && search.indexOf(`&order=${state.initialOrder}`) === -1 && workerSearch.indexOf(`&order=${state.initialOrder}`) > -1) {
      workerSearch = workerSearch.replace(`&order=${state.initialOrder}`, '');
    }

    console.log('Does API URL match current window URL?', normalizeSearch(workerSearch) !== normalizeSearch(search), workerSearch, search);

    if (normalizeSearch(workerSearch) !== normalizeSearch(search)) {
      return;
    }

    try {
      if (window.swinger.config.adCellQueryParams) {
        const { adCellQueryParams } = window.swinger.config;

        adCellQueryParams.productIds = e.data.result.map((item) => encodeURIComponent(`${item.id}`)).join('|');

        window.swinger.retargeting.adcell.container(adCellQueryParams);
      }
    } catch (e) {
      // noop
    }

    const component = getComponentName();
    const receivedItems = e.data.result.map((item) => ({
      component,
      data: item,
    }));
    if (e.data.pageNumber > 1) {
      items = items.filter((item) => !item.data.isSkeleton).concat(receivedItems);
    } else {
      items = receivedItems;
    }
    itemsLength = items.length;
    filters = e.data.filters;
    order = e.data.order;
    totalItemCount = e.data.totalItemCount;

    // If user searches for product number redirect to page
    if (
      state.q
      && totalItemCount === 1
      && e.data.result[0]
      && e.data.result[0].href
      && e.data.result[0].identifiers
      && e.data.result[0].identifiers.indexOf(state.q.toUpperCase().trim()) > -1
    ) {
      window.location = e.data.result[0].href;
      return;
    }

    if (window.performance && window.performance.measure) {
      try {
        window.performance.mark(`FilterWorker ${workerSearch} end`);
        window.performance.measure(
          'FilterWorker',
          `FilterWorker ${workerSearch} start`,
          `FilterWorker ${workerSearch} end`,
        );
      } catch (e) {
        // noop
      }
    }

    renderResults();

    if ([
      'movies',
      'scenes',
    ].indexOf(type) === -1) {
      return;
    }

    if (state.q) {
      const adCellQueryParams = createAdcellQueryParams({
        pageType: 'search',
        q: state.q,
        itemIds: e.data.result.map((item) => item.itemNumber),
      });

      window.swinger.retargeting.adcell.container(adCellQueryParams);
      return;
    }

    if (window.swinger.config.adCellQueryParams) {
      const { adCellQueryParams } = window.swinger.config;
      adCellQueryParams.productIds = e.data.result
        .slice(0, 100)
        .map((item) => item.itemNumber)
        .join(adCellQueryParams.productSeparator);

      window.swinger.retargeting.adcell.container(adCellQueryParams);
    }
  });

  const adjustResults = (e) => {
    adjustSearchIndexMetadata();

    itemsLength = 0;
    page = window.location.href.indexOf('/page/') > 1 ? Number(window.location.href.replace(/^[\d\D]+\/page\/(\d+).*$/i, '$1')) : 1;
    if (e && e.state) {
      app.store.dispatch({
        type: 'UPDATE',
        value: e.state,
      });
      itemsLength = e.state.items.length;
      return;
    }
    retrieve();
  };

  window.addEventListener('popstate', (e) => {
    console.log({ type: e.type, state: e.state });
    adjustResults(e);
  });

  app.bindEvent('submit', 'form', (e) => {
    window.requestAnimationFrame(() => {
      handleInput(e, 0);
    });
    e.preventDefault();
  });

  app.bindEvent('blur', 'input', handleBlur);

  app.bindEvent('reset', 'form', () => {
    window.requestAnimationFrame(() => {
      reset();
    });
  });

  app.bindEvent('change', 'input[type="radio"], input[name][type="checkbox"], select', (e) => {
    window.requestAnimationFrame(() => {
      handleInput(e, 0);
    });
  });

  // Fix for IE over-firing "input" event:
  const previousInputValues = new Map();

  let keyInputTimeout = 1000;
  let lastKeyUpTime = 0;

  app.bindEvent('keyup', 'input:not([type="radio"]):not([type="checkbox"]):not(select)', () => {
    const now = window.performance.now();
    const timeDifferenceToLastKeyUpTime = now - lastKeyUpTime;

    lastKeyUpTime = now;
    keyInputTimeout = Math.min(Math.round(timeDifferenceToLastKeyUpTime), 800) + 200;
  });

  app.bindEvent('input', 'input:not([type="radio"]):not([type="checkbox"]):not(select)', (e) => {
    const input = window.swinger.eventHub.getTarget(e);
    const inputName = input.name;
    const prepopulatedValue = input.getAttribute('value');
    const previousInputValue = previousInputValues.get(inputName) || prepopulatedValue || '';
    const currentInputValue = input.value;

    if (previousInputValue === currentInputValue) {
      return;
    }

    previousInputValues.set(inputName, currentInputValue);
    handleInput(e, keyInputTimeout);
  });

  app.bindEvent('search', 'input[type="search"]', (e) => {
    window.requestAnimationFrame(() => {
      handleInput(e, 0);
    });
  });

  app.bindEvent('click', '.swinger-results > a', (e) => {
    const button = window.swinger.eventHub.getTarget(e);
    const wrapper = button.closest('.swinger-results');

    elemsNextSiblingToFocus = wrapper.querySelector('.swinger-grid > li:last-child');

    console.log('Loading next page');

    window.requestAnimationFrame(() => {
      nextPage();
    });
    e.preventDefault();
  });

  app.bindEvent('click', '.swinger-tags__remove', (e) => {
    const tag = window.swinger.eventHub.getTarget(e).closest('.swinger-tags__remove');
    const value = tag.getAttribute('data-value');
    const name = tag.getAttribute('data-name');
    if (name && value) {
      reset(name, value);
    }
  });

  app.bindEvent('click', '.swinger-results__no-results-actions > a', (e) => {
    window.history.back();
    e.preventDefault();
  });

  let atTimer;

  app.bindEvent('swinger-widget:rendered', () => {
    document.documentElement.classList.remove('has-search-params');
    window.swinger.eventHub.trigger(document, 'swinger-loading-indicator:hide');

    window.clearTimeout(atTimer);
    atTimer = window.setTimeout(() => {
      if (elemsNextSiblingToFocus) {
        elemsNextSiblingToFocus.nextElementSibling.querySelector('a').focus();
        try {
          elemsNextSiblingToFocus.nextElementSibling.querySelector('a').focus();
        } catch (e) {
          // noop;
        }
      }
      elemsNextSiblingToFocus = undefined;

      window.swinger.i18n()
        .then((i18n) => {
          window.swinger.a11y.notify(i18n('ui.facetted-search.results-shown', {
            shownCount: itemsLength,
            totalCount: totalItemCount,
          }));
        })
        .catch(console.info);
    }, 1000);
  });

  url = new URL(window.location);
  const params = url.searchParams;

  if (params.has('q')) {
    params.set('order', 'best_match');
  }

  if (
    type === 'movies'
    && window.swinger.storage.get('swinger:facetted-search:last-selected-streaming-type')
    && params.has
    && !params.has('filter[streaming_type]')
    && !params.has('filter%5Bstreaming_type%5D')
    && (!state.hardwiredFilters || !state.hardwiredFilters.streaming_type)
  ) {
    params.set('filter[streaming_type]', 'scene');

    window.history.replaceState(null, document.title, url.toString());
  }

  if ((search && search !== 'filter[streaming_type]=movie') || !items.length) {
    console.log('Retrieving!', search, items.length);
    let url = decodeURI(window.location.href);
    if (url.indexOf('filter[name]=') > -1) {
      switch (true) {
        default:
        case type === 'movies':
        case type === 'scenes':
          url = url.replace('filter[name]', 'q');
          break;

        case type === 'performers':
          url = url.replace('filter[name]', 'filter[performer_title]');
          break;

        case type === 'studios':
          url = url.replace('filter[name]', 'filter[studio_title]');
          break;

        case type === 'categories':
          url = url.replace('filter[name]', 'filter[amateur_title]');
          break;

        case type === 'amateurs':
          url = url.replace('filter[name]', 'filter[amateur_title]');
          break;

        case type === 'clips':
          url = url.replace('filter[name]', 'filter[clip_title]');
          break;
      }

      window.history.replaceState(null, document.title, url);
    }
    if (url.indexOf('q=') > -1) {
      url = url.replace(/&?order=[^&]+/, '');
      url = `${url}&order=best_match`;

      switch (true) {
        default:
          break;

        case type === 'performers':
          url = url.replace('filter[name]', 'filter[performer_title]');
          break;

        case type === 'studios':
          url = url.replace('q', 'filter[studio_title]');
          break;

        case type === 'categories':
          url = url.replace('q', 'filter[category_title]');
          break;

        case type === 'amateurs':
          url = url.replace('q', 'filter[amateur_title]');
          break;

        case type === 'clips':
          url = url.replace('q', 'filter[clip_title]');
          break;
      }

      window.history.replaceState(null, document.title, url);
    }
    itemsLength = 0;
    retrieve();
  } else if (
    type === 'movies'
      && window.swinger.storage.get('swinger:facetted-search:last-selected-streaming-type')
      && (!state.hardwiredFilters || !state.hardwiredFilters.streaming_type)
  ) {
    const url = new URL(window.location);
    const params = url.searchParams;

    params.set('filter[streaming_type]', 'scene');

    window.history.replaceState(null, document.title, url.toString());

    retrieve();
  }
};



// WEBPACK FOOTER //
// ./src/_utilities/facettedsearchwidget.js